import { API } from './core'

export class Tag {
  create () {
    return API.instance().put('/tag/', this).then((resp) => {
      const item = Tag.createFromJson(resp.data.data.data)
      Tag.Cached[item.name] = item
      return item
    })
  }
  static newEmpty () {
    let tag = new Tag()
    tag.name = ''
    tag.notes = null
    return tag
  }
  static sortedItems (items) {
    return items.sort((x, y) => {
      if (x.name > y.name) {
        return 1
      }
      return -1
    })
  }
  static createFromJson (raw) {
    let tag = Tag.newEmpty()
    tag = Object.assign(tag, raw)
    return tag
  }
  static list (useFresh) {
    if (!useFresh) {
      const values = Tag.sortedItems(Object.values(Tag.Cached))
      if (values.length > 1) {
        return Promise.resolve(values)
      }
    }

    return API.instance().get('/tag/').then((resp) => {
      let data = resp.data.data.data.map((raw) => Tag.createFromJson(raw))
      data = Tag.sortedItems(data)
      data.forEach((item) => {
        Tag.Cached[item.name] = item
      })
      return data
    })
  }
}

Tag.Cached = {}
